<template>
  <div class="d-flex subscriber-avatars">
    <subscriber-avatar
      v-for="subscriber in subscribers"
      :key="subscriber.id"
      x-small
      :subscriber="subscriber"
    />
  </div>
</template>

<script>
import SubscriberAvatar from "@/components/SubscriberAvatar"

export default {
  components: {
    SubscriberAvatar
  },

  props: {
    subscribers: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.subscriber-avatars {
  .subscriber-avatar {
    margin-left: -1rem;
    border: 2px solid $color-ui--white;

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
